import { render } from "./EmployeeApproveLiquidation.vue?vue&type=template&id=b1fa4778"
import script from "./EmployeeApproveLiquidation.vue?vue&type=script&lang=js"
export * from "./EmployeeApproveLiquidation.vue?vue&type=script&lang=js"

import "./EmployeeApproveLiquidation.vue?vue&type=style&index=0&id=b1fa4778&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__